import { ImageConverterPageTemplateInterface } from "./ImageConverterPageTemplateInterface";

export const SecondaryGroupConverterJsonTemplate: ImageConverterPageTemplateInterface = {
    meta: {
        pageTitle: "page-title",
        metaDescription: "meta-description",
        metaKeywords: "meta-keywords",
    },
    section1: {
        section1Title: "section-1-title",
        section1SubTitle: "section-1-sub-title",
    },
    section2: {
        section2CtaWording1: "section-2-cta-wording-1",
        section2CtaWording2: "section-2-cta-wording-2",
    },
    section3: {
        items: [
            {
                title: "section-3-title-1",
                subTitle: "section-3-sub-title-1",
                icon: "thumbs-up",
            },
            {
                title: "section-3-title-2",
                subTitle: "section-3-sub-title-2",
                icon: "sparkles",
            },
            {
                title: "section-3-title-3",
                subTitle: "section-3-sub-title-3",
                icon: "gift",
            },
            {
                title: "section-3-title-4",
                subTitle: "section-3-sub-title-4",
                icon: "layers",
            },
            {
                title: "section-3-title-5",
                subTitle: "section-3-sub-title-5",
                icon: "zap",
            },
            {
                title: "section-3-title-6",
                subTitle: "section-3-sub-title-6",
                icon: "images",
            },
        ],
    },
    section4: {
        title: "section-4-title",
        subTexts: ["section-4-sub-text-1", "section-4-sub-text-2", "section-4-sub-text-3", "section-4-sub-text-4"],
    },
    section5: {
        title: "section-5-title",
        subTitle: "section-5-sub-title",
        subText: "section-5-sub-text",
        graphics: "/images/group-converter-section-5-image.webp",
    },
    section10: {
        title: "section-10-faq-title",
        subTitle: "section-10-faq-sub-title",
        items: [
            {
                question: "section-10-faq-item-1-question",
                answer: "section-10-faq-item-1-answer",
            },
            {
                question: "section-10-faq-item-2-question",
                answer: "section-10-faq-item-2-answer",
            },
            {
                question: "section-10-faq-item-3-question",
                answer: "section-10-faq-item-3-answer",
            },
            {
                question: "section-10-faq-item-4-question",
                answer: "section-10-faq-item-4-answer",
            },
            {
                question: "section-10-faq-item-5-question",
                answer: "section-10-faq-item-5-answer",
            },
            {
                question: "section-10-faq-item-6-question",
                answer: "section-10-faq-item-6-answer",
            },
            {
                question: "section-10-faq-item-7-question",
                answer: "section-10-faq-item-7-answer",
            },
            {
                question: "section-10-faq-item-8-question",
                answer: "section-10-faq-item-8-answer",
            },
            {
                question: "section-10-faq-item-9-question",
                answer: "section-10-faq-item-9-answer",
            }
        ],
    },
    section11: {
        title: "section-11-title",
        subTitle: "section-11-sub-title",
    },
};
